import { inject } from '@angular/core';
import { CanMatchFn, Router } from '@angular/router';
import { EnvService } from '../helpers/env.service';
import { LocaleService } from '../services/locale.service';

/** Keep all HPC pages unavailable while the module is disabled. */
export const hpcEnabledGuard: CanMatchFn = () => {
    const env = inject(EnvService);
    const router = inject(Router);
    const localeService = inject(LocaleService);

    return env.HPC_ENABLED !== false
        ? true
        : router.createUrlTree(['/', localeService.getCurrentLocale()]);
};
